<div class="outer-content">
  <div *ngIf="!productsChoice" class="col-md-12 clear-all title-wrapper fit-content-height">
    <h1 class="title-text custom-header-h2 responsive-text-8" id="yourProductChoice-error">No product available please go to your pension page</h1>
  </div>
  <div *ngIf="productsChoice" class="float-left bg-white card-background" >
    <form [formGroup]="productChoiceForm" autocomplete="off" (submit)="submit()" role="form" class="fieldHeight">
      <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='!editMode' (onBackClickHandler)="OnBackClick()"></app-content-top-nav>
      <div class="col-md-12 clear-all title-wrapper" *ngIf="productOption && productOption.length !== 1; else ageonHeading">
        <h1 class="title-text custom-header-h2 responsive-text-8" id="yourProductChoice-header">{{contentData.header}}</h1>
      </div>
      <ng-template #ageonHeading>
        <div class="col-md-12 clear-all title-wrapper">
        <h1 class="title-text custom-header-h2 responsive-text-8" id="yourProductChoice-header">{{contentData.ageonHeader}}</h1>
      </div>
      </ng-template>
    <div class ="content-fit-page">
      <div class="col-md-12 clear-all content-wrapper ">
        <p class="content-top"  id="yourProductChoice-introduction" aria-level="2">
          {{contentData.introduction}}
        </p>
      </div>
      <div *ngIf="productOption && productOption.length !== 1"  class="col-md-12 clear-all content-wrapper margin-top-50">
        <p class="sub-introduction content-top"  id="yourProductChoice-subTitle" aria-level="3">
          {{contentData.subtitle}}                        
        </p>
        </div>
      <div class="title-text">
        <div  *ngFor="let product of productOption" >
          <app-product-tiles [prodID]="product.productCode" [fundingSource]="fundingSource" [product]="product" 
              [parent]="productChoiceForm"
              [widthSize]="widthsize" 
              [isProductSelected]="isProductSelected"
              [noOfProduct]="productOption.length"
              (onProductSelectClickHandler)="onProductSelected($event, true)">
          </app-product-tiles>
          <div></div>
        </div>
        <div id="productError" style="width: 96%" class="col-xs-12 form-validation-error" *ngIf="ProductErrorValidatorFlag">
          <i class="icon icon-error" aria-hidden="true"></i>
          <p id="productChoiceError" aria-hidden="false" role="error">{{contentData.errorMessages}}</p>
        </div>
      </div>
      
      <app-modal *ngIf="displayAlert" [modalConfig]="alertModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
      (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>
      
      <ng-container *ngIf="isProductSelected">
          <app-question [questionConfig]="cmsDataQuestionPensionPot" [childId]="'pensionPotQues'"
            [parent]="productChoiceForm" [controlName]="'pensionPotQues'">
          </app-question>

          <app-question [questionConfig]="cmsDataQuestionflexwith" [childId]="'flexwithQues'"
            [parent]="productChoiceForm" [controlName]="'flexwithQues'">
          </app-question>

          <ng-container *ngIf="selectedProductCode==='H' || selectedProductCode==='G'">
            <app-question required [questionConfig]="cmsDataQuestionWithdrawingMoney" [childId]="'withdrawingMoneyQues'"
               [parent]="productChoiceForm" [controlName]="'withdrawingMoneyQues'">
            </app-question>
          </ng-container>
          <app-question [questionConfig]="cmsDataQuestionFinancialDependants" [childId]="'financialDependantsQues'"
            [parent]="productChoiceForm" [controlName]="'financialDependantsQues'">
          </app-question>        
       </ng-container>
      </div>
      <div class="col-md-12 clear-all">
        <div class="bottom-container">
          <div class="float-left">
            <app-save [location]="'contentBottom'"></app-save>
          </div>
          <div class="float-right">
            <app-content-bottom-nav (onNextHandler)="gotoNextPage()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'">
            </app-content-bottom-nav>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>